import { eligibilityApi } from '@api';
import { useQuery } from '@tanstack/react-query';

const useLocalityNamesByZipCode = (zipCode: string) => {
  return useQuery({
    queryKey: ['get-locality-names-by-zip-code', zipCode],
    queryFn: () => eligibilityApi.getLocalityNamesByZipCode(zipCode).then(({ data }) => data),
    enabled: zipCode.length === 5,
  });
};

export default useLocalityNamesByZipCode;
